module.exports = __webpack_public_path__ + "static/img/manager-dr-carlos-delgado.85da68d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager-dr-carlos-delgado.png
// module id = hAsm
// module chunks = 1